var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var handleResponse = function (contentType) { return function (response) {
    if (response.status === 401) {
        return Promise.reject({ message: 'Request failed', response: { code: response.status, content: '401 Unauthorized' } });
    }
    if (!response.ok) {
        return response.json().then(function (r) { return Promise.reject({ message: 'Request failed', response: { code: response.status, content: r } }); });
    }
    else if (response.status === 204) {
        var r = { response: { code: 204, content: null } };
        return Promise.resolve(r);
    }
    else {
        return contentType === 'application/json'
            ? response.json().then(function (r) { return ({ response: { code: response.status, content: r } }); })
            : response.text().then(function (r) { return ({ response: { code: response.status, content: r } }); });
    }
}; };
export var handleException = function (e) {
    if (!e.hasOwnProperty('response')) {
        return { response: { code: 0, content: null }, error: { message: 'There was an error processing the request', exception: e } };
    }
    var error = e;
    return { response: __assign({}, error.response), error: { message: 'There was an error processing the request', status: error.response.code } };
};
export var getContentType = function (options) { return options.request.headers.reduce(function (a, e) { return e[0] === 'Content-Type'
    ? e[1]
    : a; }, 'application/json'); };
export var call = function (options) {
    console.log(options.request.headers['Content-Type']);
    return fetch(options.url, options.request).then(handleResponse(getContentType(options))).catch(handleException);
};
export default { call: call };
//# sourceMappingURL=index.js.map